<template>
  <div class="idml-page-preview">
    <p class="small text-muted">
      Approximate preview from IDML. The imported result may differ.
    </p>
    <svg
      class="idml-page-preview__page"
      :viewBox="`${page.left || 0} ${page.top || 0} ${Math.max(page.width, 1)} ${Math.max(page.height, 1)}`"
      role="img"
      :aria-label="`Page preview for ${page.name}`"
    >
      <image
        v-if="previewPath"
        :href="publicFileUrl(previewPath)"
        :x="page.left || 0"
        :y="page.top || 0"
        :width="Math.max(page.width, 1)"
        :height="Math.max(page.height, 1)"
        preserveAspectRatio="none"
      />
      <text
        v-else
        :x="(page.left || 0) + Math.max(page.width, 1) / 2"
        :y="(page.top || 0) + Math.max(page.height, 1) / 2"
        text-anchor="middle"
        class="idml-page-preview__unavailable"
      >Backend preview is unavailable.</text>
      <g
        v-for="(node, index) in layers"
        :key="node.properties.id || index"
        class="idml-page-preview__layer"
        @click="$emit('select', node.source)"
      >
        <title>{{ node.name }}{{ node.properties.image && node.properties.image.requiresUpload ? ' — image required' : '' }}</title>
        <rect
          :x="node.left"
          :y="node.top"
          :width="Math.max(node.width, 1)"
          :height="Math.max(node.height, 1)"
          fill="transparent"
        />
        <rect
          v-if="selected === node.source"
          :x="node.left"
          :y="node.top"
          :width="Math.max(node.width, 1)"
          :height="Math.max(node.height, 1)"
          fill="none"
          stroke="#007bff"
          stroke-width="2"
          pointer-events="none"
          vector-effect="non-scaling-stroke"
        />
      </g>
      <rect
        v-if="selected && selected.children"
        :x="selected.left"
        :y="selected.top"
        :width="Math.max(selected.width, 1)"
        :height="Math.max(selected.height, 1)"
        fill="none"
        stroke="#007bff"
        stroke-width="2"
        pointer-events="none"
        vector-effect="non-scaling-stroke"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'IDMLPagePreview',
  props: {
    page: {type: Object, required: true},
    previewPath: {type: String, default: null},
    selected: {type: Object, default: null},
  },
  computed: {
    layers() {
      const result = [];
      const visit = nodes => {
        nodes.forEach(node => {
          if (node.visible === false) return;
          if (node.children && node.children.length) {
            visit(node.children);
          } else {
            result.push({...node, source: node});
          }
        });
      };
      visit(this.page.children || []);
      return result;
    },
  },
  methods: {
    publicFileUrl(path) {
      return path && path.startsWith('imports/') ? `/${path.split('/').map(encodeURIComponent).join('/')}` : null;
    },
  },
};
</script>

<style scoped>
.idml-page-preview {
  padding: 16px;
  background: #f1f3f5;
}

.idml-page-preview__page {
  display: block;
  width: 100%;
  max-height: 65vh;
  background: white;
  border: 1px solid #dee2e6;
}

.idml-page-preview__layer {
  cursor: pointer;
}

.idml-page-preview__unavailable {
  fill: #6c757d;
  font-size: 12px;
}
</style>
